<app-features-container
  header="{{ '+INSTALLATIONS.INSTALLATION.PHOTOVOLTAIC_OVERALL_TITLE' | translate }}"
  class="container"
>
  <!-- photovoltaic.production.current.consolidated -->
  <app-feature-tile
    *ngIf="
      (devicesStore.shouldUseConsolidatedFeature$ | async) &&
        (productionCurrentConsolidated$ | async | ready) as feature;
      else photovoltaicProduction
    "
    feature
    data-at-gateway-serial
    [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.PRODUCTION' | translate"
    value="{{ feature | value2: featurePropertyKey.total }} {{
      feature | unit: featurePropertyKey.total
    }}"
  ></app-feature-tile>

  <!-- photovoltaic.production.current -->
  <ng-template #photovoltaicProduction>
    <app-feature-tile
      *ngIf="productionCurrent$ | async | ready as feature"
      feature
      data-at-gateway-serial
      [label]="'+INSTALLATIONS.INSTALLATION.VITOCHARGE.PHOTOVOLTAICS.PRODUCTION' | translate"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
    ></app-feature-tile>
  </ng-template>
</app-features-container>
